// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* BORDERS */\n\n/* Icons */\n\n/* BORDERS */\n\n/* Icons */\n.vue2leaflet-map {\n  z-index: 1;\n}\n.marker-cluster-small {\n  background-color: var(--v-secondary-lighten5) !important;\n  opacity: 0.9 !important;\n}\n.marker-cluster-small div {\n  background-color: var(--v-primary-base) !important;\n  opacity: 0.9 !important;\n}", ""]);
// Exports
module.exports = exports;
